import React, { Component } from 'react';
import {
    Navbar,
    NavbarBrand,
    NavbarToggler,
    Collapse,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Container,
} from 'reactstrap';

class Navigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: [],
            svgContent: '',
            altText: '',
            isOpen: false,
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        Promise.all([
            fetch(`${process.env.REACT_APP_API_URL}/api/globals/navigation`),
            fetch(`${process.env.REACT_APP_API_URL}/api/globals/site-settings?depth=1`),
        ])
            .then(async ([navRes, settingsRes]) => {
                if (!navRes.ok) throw new Error(`Navigation fetch failed: ${navRes.status}`);
                if (!settingsRes.ok) throw new Error(`Site settings fetch failed: ${settingsRes.status}`);

                const navData = await navRes.json();
                const settingsData = await settingsRes.json();
                const headerLogo = settingsData.headerLogo;

                let svgContent = '';
                if (headerLogo?.url) {
                    const svgRes = await fetch(headerLogo.url);
                    if (svgRes.ok) {
                        svgContent = await svgRes.text();
                    } else {
                        console.warn('SVG fetch failed:', svgRes.status);
                    }
                }

                this.setState({
                    menu: navData.menu || [],
                    svgContent,
                    altText: headerLogo?.altText || 'SportStar',
                    loading: false,
                });
            })
            .catch((error) => {
                console.error('Fetch error:', error);
                this.setState({ error: error.message, loading: false });
            });
    }

    toggle = () => {
        this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
    };

    render() {
        const { menu, svgContent, altText, isOpen, loading, error } = this.state;

        if (loading) return null;
        if (error) return <p>Error: {error}</p>;

        return (
            <Navbar color="dark" dark expand="md">
                <Container>
                    <NavbarBrand href="/">
                        {svgContent ? (
                            <div
                                className="svg-logo"
                                aria-label={altText}
                                dangerouslySetInnerHTML={{ __html: svgContent }}
                                // style={{ height: '40px', width: 'auto' }}
                            />
                        ) : (
                            'Site Title'
                        )}
                    </NavbarBrand>
                    <NavbarToggler onClick={this.toggle} />
                    <Collapse isOpen={isOpen} navbar>
                        <Nav className="ms-auto" navbar>
                            {menu.map((item, index) => {
                                const hasSubItems = Array.isArray(item.subItems) && item.subItems.length > 0;

                                if (hasSubItems) {
                                    return (
                                        <UncontrolledDropdown nav inNavbar key={index}>
                                            <DropdownToggle nav caret>
                                                {item.label}
                                            </DropdownToggle>
                                            <DropdownMenu dark>
                                                {item.subItems.map((sub, subIdx) => (
                                                    <DropdownItem href={sub.url} key={subIdx}>
                                                        {sub.label}
                                                    </DropdownItem>
                                                ))}
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    );
                                }

                                return (
                                    <NavItem key={index}>
                                        <NavLink href={item.url}>{item.label}</NavLink>
                                    </NavItem>
                                );
                            })}
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>
        );
    }
}

export default Navigation;
